import { API } from "@/lib/api";
import { formatApiErrorDetail } from "@/lib/auth";

async function call(path, { method = "GET", body } = {}) {
  const res = await fetch(`${API}${path}`, {
    method,
    credentials: "include",
    headers: body ? { "Content-Type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  let payload = null;
  try {
    payload = await res.json();
  } catch {
    /* empty */
  }
  if (!res.ok) {
    const msg = formatApiErrorDetail(payload?.detail) || `Request failed (${res.status})`;
    const err = new Error(msg);
    err.status = res.status;
    err.payload = payload;
    throw err;
  }
  return payload;
}

export const apiKeysApi = {
  list: () => call("/account/api-keys"),
  usage: ({ days = 30 } = {}) => call(`/account/usage?days=${days}`),
  create: ({ name, monthly_token_cap, requests_per_minute }) =>
    call("/account/api-keys", {
      method: "POST",
      body: { name, monthly_token_cap, requests_per_minute },
    }),
  update: (id, body) =>
    call(`/account/api-keys/${id}`, { method: "PATCH", body }),
  revoke: (id) =>
    call(`/account/api-keys/${id}`, { method: "DELETE" }),
  adminList: ({ page = 1, page_size = 25, q = "" } = {}) => {
    const params = new URLSearchParams({ page, page_size });
    if (q) params.set("q", q);
    return call(`/admin/api-keys?${params.toString()}`);
  },
  adminIssue: ({ user_id, name, monthly_token_cap, requests_per_minute }) =>
    call("/admin/api-keys", {
      method: "POST",
      body: { user_id, name, monthly_token_cap, requests_per_minute },
    }),
  adminRevoke: (id) => call(`/admin/api-keys/${id}`, { method: "DELETE" }),
  adminUpdate: (id, body) => call(`/admin/api-keys/${id}`, { method: "PATCH", body }),
  // Allowlist (DB-backed beta-invite list, layered on top of the static
  // env-driven base).
  adminListAllowlist: () => call("/admin/api-keys/allowlist"),
  adminJourney: () => call("/admin/api-keys/allowlist/journey"),
  adminAddInvite: (email) =>
    call("/admin/api-keys/allowlist", { method: "POST", body: { email } }),
  adminRevokeInvite: (id) =>
    call(`/admin/api-keys/allowlist/${id}`, { method: "DELETE" }),
  adminResendInvite: (id) =>
    call(`/admin/api-keys/allowlist/${id}/resend`, { method: "POST" }),
};

export const billingApi = {
  config: () => call("/billing/config"),
  checkout: ({ tier, origin_url }) =>
    call("/billing/checkout", { method: "POST", body: { tier, origin_url } }),
  status: (sessionId) => call(`/billing/status/${sessionId}`),
};
